import { supabase } from './supabase';

type ModeloMensagem = {
  id?: number;
  codempresa: number | null;  // Pode ser nulo para modelos padrão
  modelo: string;
  n8n: boolean;
};

export const modeloMensagemService = {
  async getModelos(codempresa?: number): Promise<ModeloMensagem[]> {
    // Se não tiver codempresa definido, retorna os modelos padrão
    if (!codempresa) {
      return [
        {
          id: -1,
          codempresa: null,
          ...this.getModeloPadrao(false)
        },
        {
          id: -2,
          codempresa: null,
          ...this.getModeloPadrao(true)
        }
      ];
    }


    // Busca os modelos da empresa
    const { data, error } = await supabase
      .from('modelomensagem')
      .select('*')
      .eq('codempresa', codempresa)
      .order('id', { ascending: true });

    if (error) throw error;
    
    // Se não encontrar modelos para a empresa, retorna os padrão
    if (!data || data.length === 0) {
      // Busca os modelos padrão (com codempresa null)
      const { data: modelosPadrao, error: errorPadrao } = await supabase
        .from('modelomensagem')
        .select('*')
        .is('codempresa', null)
        .order('id', { ascending: true });
      
      if (errorPadrao) throw errorPadrao;
      
      // Se encontrar modelos padrão, retorna eles
      if (modelosPadrao && modelosPadrao.length > 0) {
        return modelosPadrao;
      }
      
      // Se não encontrar, retorna os modelos padrão embutidos
      return [
        {
          id: -1,
          codempresa: null,
          ...this.getModeloPadrao(false)
        },
        {
          id: -2,
          codempresa: null,
          ...this.getModeloPadrao(true)
        }
      ];
    }
    
    return data;
  },

  async getModeloById(id: number): Promise<ModeloMensagem | null> {
    const { data, error } = await supabase
      .from('modelomensagem')
      .select('*')
      .eq('id', id)
      .single();

    if (error) return null;
    return data;
  },

  async createModelo(modelo: Omit<ModeloMensagem, 'id'>): Promise<ModeloMensagem> {
    const { data, error } = await supabase
      .from('modelomensagem')
      .insert([modelo])
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async updateModelo(id: number, updates: Partial<ModeloMensagem>): Promise<ModeloMensagem> {
    const { data, error } = await supabase
      .from('modelomensagem')
      .update(updates)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async deleteModelo(id: number): Promise<void> {
    const { error } = await supabase
      .from('modelomensagem')
      .delete()
      .eq('id', id);

    if (error) throw error;
  },

  // Modelos padrão que serão usados como base
  getModeloPadrao(n8n: boolean): Omit<ModeloMensagem, 'id' | 'codempresa'> {
    if (n8n) {
      return {
        modelo: `⚠️ Aviso de Títulos em Atraso ⚠️\n\nSetor de cobrança:\nMascarenhas e Lins Distribuidora\n\nPrezado Cliente: [cliente]\n\nInformações gerais:\n- Código do Cliente: [codcli]\n- CNPJ: [cgc]\n- Valor Total em Débito: R$ [valordeb]\n- Quantidade de Títulos: [qtdetitul]\n- Data do Primeiro Vencimento: [mindtvenc]\n- Data do Último Vencimento: [maxdtvenc]\n\nDetalhes dos títulos em atraso:\n[titulos]\n\nCaso haja alguma dúvida referente a esses títulos ou se desejar informações sobre próximos vencimentos, por favor, não hesite em nos contatar. Estamos à disposição para assisti-lo tanto por este canal de comunicação quanto pelos telefones (82)99987-0361, de segunda a sexta-feira, das 8:00 às 12:00 e 14:00 às 17:30h.\n\nAgradecemos a sua atenção e reiteramos o nosso compromisso em oferecer suporte no que for necessário.\n\nDepartamento de Cobrança\n📍Nome da Distribuidora\nCNPJ: 99.999.999/0001-99.\n\nCaso o pagamento já tenha sido efetuado favor desconsiderar a mensagem.`,
        n8n: true
      };
    } else {
      return {
        modelo: `Setor de cobrança:\nMascarenhas e Lins Distribuidora\n\n⚠️TÍTULO EM ABERTO⚠️\n\nPrezado Cliente:  [cliente]\n\nPor meio deste comunicado, gostaríamos de informar que o seu título de número [duplic], no valor de R$ [valortitulo], com vencimento em [dtvenc], encontra-se pendente.\nAbaixo linha digitável do boleto para pagamento em qualquer banco:\n[linhadig]\n\nCaso haja alguma dúvida referente a este título ou se desejar informações sobre próximos vencimentos, por favor, não hesite em nos contatar. Estamos à disposição para assisti-lo tanto por este canal de comunicação quanto pelos telefones (82)99987-0361, de segunda a sexta-feira, das 8:00 às 12:00 e 14:00 às 17:30h.\n\nAgradecemos a sua atenção e reiteramos o nosso compromisso em oferecer suporte no que for necessário.\n\nDepartamento de Cobrança\n📍Nome da Distribuidora\nCNPJ: 99.999.999/0001-99.\n\nCaso o pagamento já tenha sido efetuado favor desconsiderar a mensagem.`,
        n8n: false
      };
    }
  }
};
